<template>
  <div>
    <nav class="navbar navbar-light bg-light navbar-expand-sm row">
      <div class="navbar-brand">
        <router-link to="/">
          <span class="navbar-brand col">Lettre Compte Triple</span>
        </router-link>
      </div>
      <button type="button"
        class="navbar-toggler"
        aria-label="Toggle navigation"
        aria-controls="bottom-collapse"
        v-bind:aria-expanded="navOpen ? 'true' : 'false'"
        v-on:click="navOpen = !navOpen">
        <span class="navbar-toggler-icon"></span>
      </button>

      <Transition
        enter-from-class="" enter-active-class="collapsing" enter-to-class=""
        leave-from-class="" leave-active-class="collapsing" leave-to-class=""
        v-on:enter="collapseEnter" v-on:after-enter="collapseAfter"
        v-on:leave="collapseLeave" v-on:after-leave="collapseAfter">
        <div id="bottom-collapse" class="navbar-collapse col"
          v-bind:class="{ collapse: !transitioning, show: navOpen && !transitioning }"
          v-show="navOpen"
          v-on:click="collapseClick">
          <ul class="navbar-nav">
            <router-link to="/rules">
                <span class="nav-link">Règle</span>
            </router-link>
          </ul>
          <ul class="navbar-nav">
            <router-link to="/contact" v-if="username">
                <span class="nav-link">Contact</span>
              </router-link>
          </ul>
          <ul class="navbar-nav">
            <router-link to="/mention-legales">
                <span class="nav-link">Mentions légales</span>
              </router-link>
          </ul>
          <ul class="navbar-nav">
            <router-link to="/confidentialite">
                <span class="nav-link">Confidentialité</span>
              </router-link>
          </ul>
        </div>
      </Transition>
    </nav>
  </div>
</template>

<script>
import iam from '../iam';

export default {
  name: 'Bottom-Nav',
  data() {
    return {
      username: iam.getConnectedUser() ? iam.getConnectedUser().username : undefined,
      navOpen: false,
      transitioning: false,
    };
  },
  methods: {
    // Ouverture et fermeture animées du menu replié (petits écrans), comme le <b-collapse> de bootstrap-vue
    collapseEnter(el) {
      el.style.height = 0;
      el.getBoundingClientRect();
      el.style.height = `${el.scrollHeight}px`;
      this.transitioning = true;
    },
    collapseLeave(el) {
      el.style.height = 'auto';
      el.style.display = 'block';
      el.style.height = `${el.getBoundingClientRect().height}px`;
      el.getBoundingClientRect();
      this.transitioning = true;
      el.style.height = 0;
    },
    collapseAfter(el) {
      el.style.height = null;
      this.transitioning = false;
    },
    // un lien choisi dans le menu déplié le referme
    collapseClick(event) {
      if (getComputedStyle(this.$el.querySelector('#bottom-collapse')).display === 'block'
        && event.target.closest('.nav-link, .dropdown-item')) {
        this.navOpen = false;
      }
    },
  },
};
</script>

<style>
.navbar {
  font-size: 0.85rem;
}
.navbar-brand {
  font-size: 0.85rem;
}
.nav-link{
  font-size: 0.85rem;
}
</style>
